import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlPanelComponent } from './control-panel.component';
import { HeaderModule } from 'src/app/components/header/header.module';
import { MenuModule } from 'src/app/components/menu/menu.module';
import { MenuFooterModule } from 'src/app/components/menu-footer/menu-footer.module';
import { HeaderInSectionModule } from 'src/app/components/header-in-section/header-in-section.module';
import { BodyControlPanelModule } from './body-control-panel/body-control-panel.module';
import { ModalModule } from 'src/app/components/dialogs/modal.module';

@NgModule({
  declarations: [
    ControlPanelComponent
  ],
  imports: [
    CommonModule,
    HeaderModule,
    MenuModule,
    MenuFooterModule,
    HeaderInSectionModule,
    BodyControlPanelModule,
    ModalModule
  ], exports: [
    ControlPanelComponent
  ]
})
export class ControlPanelModule { }
